import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faAddressBook,
  faUserTag,
  faUserMd,
  faStar,
  faBug,
  faCheckSquare,
  faEye,
  faCloudUploadAlt,
  faCopy,
  faBuilding,
  faPhone,
  faAt,
  faHome,
  faCogs,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faSearch,
  faPlus,
  faUsers,
  faCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faMinus,
  faSave,
  faTimes,
  faCalendarAlt,
  faClock,
  faUserCircle,
  faExternalLinkAlt,
  faSyncAlt,
  faBan,
  faTrash,
  faComments,
  faMobileAlt,
  faBell,
  faBellSlash,
  faClipboardList,
  faTachometerAlt,
  faUserEdit,
  faFilter,
  faFileExport,
  faChartLine,
  faQuestionCircle,
  faCog,
  faCut,
  faExpand,
  faCompress,
  faUser,
  faEnvelopeOpenText,
  faHospital,
  faPrint,
  faBook,
  faHandshake,
  faPen,
} from '@fortawesome/free-solid-svg-icons';

import {
  faComment,
  faSquare,
} from '@fortawesome/free-regular-svg-icons';

import 'react-toastify/dist/ReactToastify.css';

import '@cordata/buffet/build/yup';

import './config/i18n';

import './styles/manifest.scss';
import { App } from './components';
import * as serviceWorker from './serviceWorker';

import { makeServer } from './server';

library.add(
  faAddressBook,
  faUserTag,
  faUserMd,
  faStar,
  faBug,
  faCheckSquare,
  faSquare,
  faPen,
  faEye,
  faCloudUploadAlt,
  faCopy,
  faBuilding,
  faPhone,
  faAt,
  faHome,
  faCogs,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faSearch,
  faPlus,
  faUsers,
  faCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faMinus,
  faSave,
  faTimes,
  faCalendarAlt,
  faClock,
  faUserCircle,
  faExternalLinkAlt,
  faSyncAlt,
  faBan,
  faTrash,
  faComments,
  faComment,
  faMobileAlt,
  faBell,
  faBellSlash,
  faClipboardList,
  faTachometerAlt,
  faUserEdit,
  faFilter,
  faFileExport,
  faChartLine,
  faQuestionCircle,
  faCog,
  faCut,
  faExpand,
  faCompress,
  faUser,
  faEnvelopeOpenText,
  faHospital,
  faPrint,
  faBook,
  faHandshake,
);

if (process.env.NODE_ENV === 'development') {
  makeServer({ environment: 'development' });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
